import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahServiceTypeAssociations } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahServiceTypeAssociation } from '~lookups/models';

import { ServiceTypeRow } from '~appointments/reducers/serviceTypes';

export const typePrefix = `sah-service-type-associations`;

type AssocsResponse = {
  rows: SahServiceTypeAssociation[];
  total: number;
};

type SahServiceResponse = {
  id: string;
  items: any[];
  wraps: any[];
};

export const sahServiceTypeAssociationsApi = createApi({
  reducerPath: 'sahServiceTypeAssociationsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahServiceTypeAssociations }),
  tagTypes: ['sah-service-type-associations'],
  endpoints: (builder) => ({
    getAssocs: builder.query<AssocsResponse, Request | void>({
      query: (params) => ({ url: '', method: 'GET', params: { sort: ['category.name', 'name'], ...params } }),
      providesTags: [{ type: 'sah-service-type-associations', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AssocsResponse>(payload),
    }),
    updateAssoc: builder.mutation<void, Request>({
      query: (body) => ({ url: '', method: 'POST', body }),
      invalidatesTags: [{ type: 'sah-service-type-associations', id: 'LIST' }],
      transformResponse: (payload) => unwrap<void>(payload),
    }),
    getAssocByServiceType: builder.query<SahServiceResponse, { id: string }>({
      query: ({ id }) => ({ url: `/service-type/${id}`, method: 'GET' }),
      providesTags: (_result, _error, { id }) => [{ type: 'sah-service-type-associations', id }],
      transformResponse: (payload) => unwrap<SahServiceResponse>(payload),
    }),
    getAssignableServiceTypes: builder.query<ServiceTypeRow[], Request | void>({
      query: () => ({
        url: `/assignable-service-types`,
        method: 'GET',
      }),
      providesTags: [{ type: 'sah-service-type-associations', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ServiceTypeRow[]>(payload),
    }),
  }),
});

export const {
  useGetAssocsQuery,
  useUpdateAssocMutation,
  useLazyGetAssocByServiceTypeQuery,
  useGetAssignableServiceTypesQuery,
} = sahServiceTypeAssociationsApi;
